/* DRIP LADY — fly-to-cart + ajax intercept */
;(function(){
  if (window.__dl_atc_combined) return;
  window.__dl_atc_combined = true;

  // ====== RELOC ======
  function moveQB(card){
    if (!card || card.dataset.dlAtcMoved) return;
    var qb = card.querySelector('.product-card__quick-buy');
    if (!qb) return;
    if (qb.parentElement === card) { card.dataset.dlAtcMoved = '1'; return; }
    card.appendChild(qb);
    card.dataset.dlAtcMoved = '1';
  }
  function moveAll(){
    document.querySelectorAll('product-card.product-card, .product-card').forEach(moveQB);
  }

  // ====== STYLES ======
  function injectStyles(){
    if (document.getElementById('dl-fly-styles')) return;
    var css = [
      '.dl-fly{position:fixed;border-radius:14px;object-fit:cover;z-index:99999;pointer-events:none;box-shadow:0 18px 48px rgba(53,205,208,.45);transition:transform .9s cubic-bezier(.55,0,.35,1),opacity .9s ease,width .9s ease,height .9s ease,border-radius .9s ease;}',
      '@keyframes dl-cart-pulse{0%{transform:scale(1)}30%{transform:scale(1.25);filter:drop-shadow(0 0 12px rgba(53,205,208,.6))}60%{transform:scale(.92)}100%{transform:scale(1)}}',
      '.dl-cart-pulse{animation:dl-cart-pulse .7s cubic-bezier(.3,.7,.4,1.3)!important}',
      '@keyframes dl-badge-pop{0%{transform:scale(.5);opacity:0}50%{transform:scale(1.4)}100%{transform:scale(1);opacity:1}}',
      '.dl-badge-pop{animation:dl-badge-pop .55s cubic-bezier(.3,.7,.4,1.3)!important}',
      '.dl-cart-ring{position:fixed;border:2px solid #35cdd0;border-radius:50%;pointer-events:none;z-index:99998;opacity:0;animation:dl-ring 1s ease-out forwards}',
      '@keyframes dl-ring{0%{transform:scale(.3);opacity:.8}100%{transform:scale(2.5);opacity:0}}'
    ].join('');
    var s=document.createElement('style'); s.id='dl-fly-styles'; s.textContent=css; document.head.appendChild(s);
  }

  // ====== TARGETS ======
  function getCartTarget(){
    var sels = ['.header__cart-link a','a[aria-controls="cart-drawer"]','header-cart-link','.icon-cart','[href$="/cart"]','[href*="/cart"]'];
    for (var i=0; i<sels.length; i++){
      var el = document.querySelector(sels[i]);
      if (el && el.getBoundingClientRect().width > 0) return el;
    }
    return null;
  }
  function getCardImage(srcEl){
    var card = srcEl.closest && srcEl.closest('product-card, .product-card');
    if (card){
      var img = card.querySelector('img');
      if (img) return img;
    }
    var modal = srcEl.closest && srcEl.closest('quick-buy-modal, .modal--quick-buy');
    if (modal){
      var img2 = modal.querySelector('img');
      if (img2) return img2;
    }
    return null;
  }

  // ====== FLY-TO-CART ======
  function flyToCart(sourceImg, originRect){
    injectStyles();
    var target = getCartTarget();
    if (!target || !sourceImg) return;
    var tr = target.getBoundingClientRect();
    var sr = originRect || sourceImg.getBoundingClientRect();

    var clone = document.createElement('img');
    clone.src = sourceImg.currentSrc || sourceImg.src;
    clone.className = 'dl-fly';
    var startSize = Math.min(120, Math.max(60, sr.width * 0.45));
    clone.style.width = startSize + 'px';
    clone.style.height = startSize + 'px';
    clone.style.left = (sr.left + sr.width/2 - startSize/2) + 'px';
    clone.style.top = (sr.top + sr.height/2 - startSize/2) + 'px';
    clone.style.opacity = '1';
    document.body.appendChild(clone);

    var tx = tr.left + tr.width/2 - (sr.left + sr.width/2);
    var ty = tr.top + tr.height/2 - (sr.top + sr.height/2);

    requestAnimationFrame(function(){
      clone.style.transform = 'translate(' + tx + 'px,' + ty + 'px) rotate(20deg) scale(.12)';
      clone.style.opacity = '0';
      clone.style.borderRadius = '50%';
    });

    setTimeout(function(){
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      pulseCart(target, tr);
    }, 750);
  }

  function pulseCart(target, tr){
    target.classList.add('dl-cart-pulse');
    setTimeout(function(){ target.classList.remove('dl-cart-pulse'); }, 800);

    var ring = document.createElement('div');
    ring.className = 'dl-cart-ring';
    var rs = 36;
    ring.style.width = rs + 'px';
    ring.style.height = rs + 'px';
    ring.style.left = (tr.left + tr.width/2 - rs/2) + 'px';
    ring.style.top = (tr.top + tr.height/2 - rs/2) + 'px';
    document.body.appendChild(ring);
    setTimeout(function(){ if (ring.parentNode) ring.parentNode.removeChild(ring); }, 1000);

    document.querySelectorAll('[data-cart-count],.cart-link__bubble,.cart-count,cart-count,.header__active-dot,.cart-link__bubble-num').forEach(function(el){
      el.classList.remove('dl-badge-pop'); void el.offsetWidth; el.classList.add('dl-badge-pop');
    });
  }

  // ====== CART REFRESH ======
  function refreshCart(){
    return fetch('/cart.js', { credentials:'same-origin' }).then(function(r){return r.json();}).then(function(c){
      ['[data-cart-count]','.cart-link__bubble','header-cart-bubble','.cart-count','cart-count','.header__active-dot','.cart-link__bubble-num'].forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(el){ el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); if (c.item_count > 0) el.removeAttribute('hidden'); });
      });
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles:true, detail:{ baseEvent:'variant:add', cart: c }})); } catch(e){}
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true })); } catch(e){}
      return c;
    });
  }

  // ====== CLOSE MODAL ======
  function closeModal(){
    document.querySelectorAll('quick-buy-modal, .modal--quick-buy').forEach(function(m){
      try { if (typeof m.close === 'function') m.close(); } catch(e){}
      m.removeAttribute('open');
      m.classList.remove('is-open','open');
      m.setAttribute('aria-hidden','true');
    });
  }

  // ====== AJAX ADD ======
  function ajaxAddFromForm(form){
    var fd = new FormData(form);
    return fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{ 'Accept':'application/json' }, body: fd })
      .then(function(r){ if(!r.ok) return r.text().then(function(t){ throw new Error('add failed: '+t); }); return r.json(); });
  }

  // ====== SUBMIT INTERCEPT ======
  function onSubmit(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var inCardQB = !!form.closest('.product-card__quick-buy');
    var inModal = !!form.closest('quick-buy-modal, .modal--quick-buy');
    if (!inCardQB && !inModal) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (form.dataset.dlBusy) return;
    form.dataset.dlBusy = '1';

    var srcImg = getCardImage(form);
    var srcRect = srcImg ? srcImg.getBoundingClientRect() : null;

    ajaxAddFromForm(form).then(function(){
      flyToCart(srcImg, srcRect);
      return refreshCart();
    }).then(function(){
      if (inModal) setTimeout(closeModal, 600);
    }).catch(function(err){
      console.warn('DL-ATC', err);
    }).then(function(){ delete form.dataset.dlBusy; });
  }

  // ====== INIT ======
  function runAll(){ moveAll(); injectStyles(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else { runAll(); }
  try {
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(n){
          if (!(n instanceof Element)) return;
          if (n.matches && n.matches('product-card.product-card, .product-card')) moveQB(n);
          if (n.querySelectorAll) n.querySelectorAll('product-card.product-card, .product-card').forEach(moveQB);
        });
      });
    }).observe(document.documentElement, { childList:true, subtree:true });
  } catch(e){}

  document.addEventListener('submit', onSubmit, true);
})();
